<template>
  <div class="admin-page">
        <div class="admin-toolbar">
      <div class="admin-toolbar__actions">
            <el-button type="primary" @click="refreshList">
              <el-icon><Refresh /></el-icon>
              刷新列表
            </el-button>
          </div>
        </div>
        
        <!-- 待审核身份证列表 -->
        <el-table :data="pendingIdcards" v-loading="loading" style="width: 100%">
          <el-table-column prop="id" label="ID" width="80" />
          <el-table-column prop="user_id" label="用户ID" width="100" />
          <el-table-column prop="req_name" label="申请姓名" width="120" />
          <el-table-column prop="req_idcard_num" label="申请身份证号" width="180" />
          <el-table-column prop="name" label="识别姓名" width="120" />
          <el-table-column prop="idcard_num" label="识别身份证号" width="180" />
          <el-table-column label="身份证正面" width="120">
            <template #default="scope">
              <el-image 
                v-if="scope.row.image_front"
                :src="photoPathToUrl(scope.row.image_front)"
                :preview-src-list="[photoPathToUrl(scope.row.image_front)]"
                :preview-teleported="true"
                :z-index="5000"
                fit="cover"
                style="width: 80px; height: 50px; border-radius: 4px;"
              />
              <span v-else class="no-image-text">未上传</span>
            </template>
          </el-table-column>
          <el-table-column label="身份证反面" width="120">
            <template #default="scope">
              <el-image 
                v-if="scope.row.image_back"
                :src="photoPathToUrl(scope.row.image_back)"
                :preview-src-list="[photoPathToUrl(scope.row.image_back)]"
                :preview-teleported="true"
                :z-index="5000"
                fit="cover"
                style="width: 80px; height: 50px; border-radius: 4px;"
              />
              <span v-else class="no-image-text">未上传</span>
            </template>
          </el-table-column>
          <el-table-column prop="audit_status" label="审核状态" width="100">
            <template #default="scope">
              <el-tag :type="getStatusType(scope.row.audit_status)">
                {{ getStatusText(scope.row.audit_status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="提交时间" width="160">
            <template #default="scope">
              {{ formatDate(scope.row.created_at) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template #default="scope">
              <div class="action-buttons">
                <el-button 
                  size="small" 
                  type="success" 
                  @click="quickApprove(scope.row)"
                  :disabled="scope.row.audit_status !== 1"
                  :loading="scope.row.approving"
                >
                  通过
                </el-button>
                <el-button 
                  size="small" 
                  type="danger" 
                  @click="quickDeny(scope.row)"
                  :disabled="scope.row.audit_status !== 1"
                  :loading="scope.row.denying"
                >
                  拒绝
                </el-button>
                <el-button 
                  size="small" 
                  type="primary" 
                  @click="viewAuditDetail(scope.row)"
                  :disabled="scope.row.audit_status !== 1"
                >
                  详情
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        
        <AdminPagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
    <!-- 审核详情对话框 -->
    <el-dialog
      v-model="auditDialogVisible"
      title="身份证审核"
      width="90%"
      :close-on-click-modal="false"
    >
      <div v-if="auditDetail" class="audit-detail">
        <!-- 基本信息 -->
        <div class="basic-info">
          <h3>基本信息</h3>
          <el-descriptions :column="2" border>
            <el-descriptions-item label="用户ID">{{ auditDetail.user_id }}</el-descriptions-item>
            <el-descriptions-item label="申请姓名">{{ auditDetail.req_name }}</el-descriptions-item>
            <el-descriptions-item label="申请身份证号">{{ auditDetail.req_idcard_num }}</el-descriptions-item>
            <el-descriptions-item label="提交时间">{{ formatDate(auditDetail.created_at) }}</el-descriptions-item>
          </el-descriptions>
        </div>

        <!-- 身份证图片 -->
        <div class="idcard-images">
          <h3>身份证图片</h3>
          <div class="image-row">
            <div class="image-item">
              <h4>身份证正面</h4>
              <el-image
                v-if="auditDetail.image_front"
                :src="photoPathToUrl(auditDetail.image_front)"
                :preview-src-list="[photoPathToUrl(auditDetail.image_front)]"
                :preview-teleported="true"
                :z-index="5000"
                fit="contain"
                style="width: 300px; height: 200px; border: 1px solid #ddd;"
              />
              <div v-else class="no-image">未上传</div>
            </div>
            <div class="image-item">
              <h4>身份证反面</h4>
              <el-image
                v-if="auditDetail.image_back"
                :src="photoPathToUrl(auditDetail.image_back)"
                :preview-src-list="[photoPathToUrl(auditDetail.image_back)]"
                :preview-teleported="true"
                :z-index="5000"
                fit="contain"
                style="width: 300px; height: 200px; border: 1px solid #ddd;"
              />
              <div v-else class="no-image">未上传</div>
            </div>
          </div>
        </div>

        <!-- 识别信息对比 -->
        <div class="recognition-info">
          <h3>识别信息对比</h3>
          <el-table :data="comparisonData" border style="width: 100%">
            <el-table-column prop="field" label="字段" width="120" />
            <el-table-column prop="userInput" label="用户输入" />
            <el-table-column prop="recognized" label="系统识别" />
            <el-table-column prop="status" label="匹配状态" width="100">
              <template #default="scope">
                <el-tag :type="scope.row.match ? 'success' : 'danger'">
                  {{ scope.row.match ? '匹配' : '不匹配' }}
                </el-tag>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 详细识别信息 -->
        <div v-if="hasDetailedInfo" class="detailed-info">
          <h3>详细识别信息</h3>
          <el-descriptions :column="2" border>
            <el-descriptions-item label="性别">{{ getGenderText(auditDetail.gender) }}</el-descriptions-item>
            <el-descriptions-item label="民族">{{ auditDetail.ethnicity || '未识别' }}</el-descriptions-item>
            <el-descriptions-item label="出生日期">{{ auditDetail.birthday || '未识别' }}</el-descriptions-item>
            <el-descriptions-item label="地址">{{ auditDetail.address || '未识别' }}</el-descriptions-item>
            <el-descriptions-item label="发证机关">{{ auditDetail.issuing_authority || '未识别' }}</el-descriptions-item>
            <el-descriptions-item label="有效期限">{{ auditDetail.validity_period || '未识别' }}</el-descriptions-item>
          </el-descriptions>
        </div>

        <!-- 审核操作 -->
        <div class="audit-actions">
          <el-form :model="auditForm" label-width="100px">
            <el-form-item label="审核结果" required>
              <el-radio-group v-model="auditForm.auditStatus">
                <el-radio :label="2">通过</el-radio>
                <el-radio :label="3">拒绝</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item 
              label="拒绝原因" 
              v-if="auditForm.auditStatus === 3"
              required
            >
              <div class="reject-reasons">
                <div class="predefined-reasons">
                  <h5>常见拒绝原因（点击快速选择）：</h5>
                  <div class="reason-buttons">
                    <el-button 
                      v-for="reason in predefinedReasons" 
                      :key="reason"
                      size="small"
                      type="info"
                      plain
                      @click="selectPredefinedReason(reason)"
                      :class="{ 'selected-reason': auditForm.failReason === reason }"
                    >
                      {{ reason }}
                    </el-button>
                  </div>
                </div>
                <div class="custom-reason">
                  <h5>自定义原因：</h5>
                  <el-input 
                    v-model="auditForm.failReason" 
                    type="textarea" 
                    :rows="3"
                    placeholder="请选择上方常见原因或输入自定义拒绝原因"
                  />
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="auditDialogVisible = false">取消</el-button>
          <el-button 
            type="primary" 
            @click="submitAudit" 
            :loading="submitting"
            :disabled="auditForm.auditStatus === 3 && !auditForm.failReason.trim()"
          >
            提交审核
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 拒绝原因对话框 -->
    <el-dialog
      v-model="denyDialogVisible"
      title="拒绝身份证审核"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="reject-reasons">
        <div class="predefined-reasons">
          <h5>常见拒绝原因（点击快速选择）：</h5>
          <div class="reason-buttons">
            <el-button 
              v-for="reason in predefinedReasons" 
              :key="reason"
              size="small"
              type="info"
              plain
              @click="selectQuickDenyReason(reason)"
              :class="{ 'selected-reason': denyForm.failReason === reason }"
            >
              {{ reason }}
            </el-button>
          </div>
        </div>
        <div class="custom-reason">
          <h5>自定义原因：</h5>
          <el-input
            v-model="denyForm.failReason"
            type="textarea"
            :rows="4"
            placeholder="请选择上方常见原因或输入自定义拒绝原因..."
            maxlength="200"
            show-word-limit
          />
        </div>
      </div>
      
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="denyDialogVisible = false">取消</el-button>
          <el-button 
            type="danger" 
            @click="confirmDeny"
            :loading="submitting"
            :disabled="!denyForm.failReason.trim()"
          >
            确认拒绝
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Refresh } from '@element-plus/icons-vue'
import AdminPagination from '@/components/AdminPagination.vue'
import axios from 'axios'
import { photoPathToUrl } from '@/utils/photoUpload'

export default {
  name: 'IdCardAuditView',
  components: {
    AdminPagination,
    Refresh
  },
  setup() {
    const loading = ref(false)
    const submitting = ref(false)
    const pendingIdcards = ref([])
    const currentPage = ref(1)
    const pageSize = ref(10)
    const total = ref(0)
    const auditDialogVisible = ref(false)
    const auditDetail = ref(null)
    const auditForm = ref({
      auditStatus: 2,
      failReason: ''
    })
    const denyDialogVisible = ref(false)
    const denyForm = ref({
      id: null,
      failReason: ''
    })

    // 预定义拒绝原因
    const predefinedReasons = [
      '身份证图片模糊不清',
      '身份证照片不完整',
      '身份证已过期',
      '身份证信息与用户输入不符',
      '身份证照片疑似伪造',
      '身份证反光严重无法识别',
      '提供的不是身份证照片',
      '身份证照片角度不正确',
      '身份证信息无法识别',
      '重复提交审核'
    ]

    // 计算是否有详细识别信息
    const hasDetailedInfo = computed(() => {
      if (!auditDetail.value) return false
      return auditDetail.value.gender || 
             auditDetail.value.ethnicity || 
             auditDetail.value.birthday || 
             auditDetail.value.address || 
             auditDetail.value.issuing_authority || 
             auditDetail.value.validity_period
    })

    // 计算对比数据
    const comparisonData = computed(() => {
      if (!auditDetail.value) return []
      return [
        {
          field: '姓名',
          userInput: auditDetail.value.req_name || '未填写',
          recognized: auditDetail.value.name || '未识别',
          match: auditDetail.value.req_name === auditDetail.value.name
        },
        {
          field: '身份证号',
          userInput: auditDetail.value.req_idcard_num || '未填写',
          recognized: auditDetail.value.idcard_num || '未识别',
          match: auditDetail.value.req_idcard_num === auditDetail.value.idcard_num
        }
      ]
    })

    // 格式化日期
    const formatDate = (timestamp) => {
      if (!timestamp) return ''
      const date = new Date(typeof timestamp === 'number' ? timestamp * 1000 : timestamp)
      return date.toLocaleString()
    }

    // 获取审核状态文本
    const getStatusText = (status) => {
      const statusMap = {
        0: '未上传',
        1: '审核中',
        2: '审核通过',
        3: '审核未通过'
      }
      return statusMap[status] || '未知'
    }

    // 获取审核状态类型
    const getStatusType = (status) => {
      const typeMap = {
        0: 'info',
        1: 'warning',
        2: 'success',
        3: 'danger'
      }
      return typeMap[status] || 'info'
    }

    // 获取性别文本
    const getGenderText = (gender) => {
      const genderMap = {
        1: '男',
        2: '女'
      }
      return genderMap[gender] || '未识别'
    }

    // 获取待审核身份证列表
    const fetchPendingIdcards = async () => {
      loading.value = true
      try {
        const token = localStorage.getItem('jwt_token')
        const response = await axios.post('/api/v1/admin/idcard/verify/list', {
          page: currentPage.value,
          page_size: pageSize.value
        }, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })
        
        if (response.data.code === 200) {
          pendingIdcards.value = response.data.data.list || []
          total.value = response.data.data.total || 0
        } else {
          ElMessage.error(response.data.message || '获取身份证审核列表失败')
        }
      } catch (error) {
        console.error('Error fetching pending idcards:', error)
        ElMessage.error('获取身份证审核列表失败')
      } finally {
        loading.value = false
      }
    }

    // 查看审核详情
    const viewAuditDetail = (idcard) => {
      auditDetail.value = idcard
      auditForm.value = {
        auditStatus: 2,
        failReason: ''
      }
      auditDialogVisible.value = true
    }

    // 提交审核
    const submitAudit = async () => {
      if (!auditDetail.value) return

      // 验证表单
      if (auditForm.value.auditStatus === 3 && !auditForm.value.failReason.trim()) {
        ElMessage.error('请填写拒绝原因')
        return
      }

      try {
        await ElMessageBox.confirm(
          `确定要${auditForm.value.auditStatus === 2 ? '通过' : '拒绝'}该身份证审核吗？`, 
          '确认审核', 
          {
            type: 'warning'
          }
        )

        submitting.value = true
        const token = localStorage.getItem('jwt_token')
        const response = await axios.post('/api/v1/admin/idcard/audit', {
          id: auditDetail.value.id,
          audit_status: auditForm.value.auditStatus,
          fail_reason: auditForm.value.auditStatus === 3 ? auditForm.value.failReason : ''
        }, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })
        
        if (response.data.code === 200) {
          ElMessage.success('审核提交成功')
          auditDialogVisible.value = false
          fetchPendingIdcards()
        } else {
          ElMessage.error(response.data.message || '审核提交失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('Error submitting audit:', error)
          ElMessage.error('审核提交失败')
        }
      } finally {
        submitting.value = false
      }
    }

    // 刷新列表
    const refreshList = () => {
      fetchPendingIdcards()
    }

    // 分页处理
    const handleSizeChange = (val) => {
      pageSize.value = val
      currentPage.value = 1
      fetchPendingIdcards()
    }

    const handlePageChange = (val) => {
      currentPage.value = val
      fetchPendingIdcards()
    }

    // 快速通过
    const quickApprove = async (idcard) => {
      try {
        await ElMessageBox.confirm(
          `确定要通过用户 ${idcard.req_name} 的身份证审核吗？`, 
          '确认通过', 
          {
            type: 'success'
          }
        )

        // 设置加载状态
        idcard.approving = true
        
        const token = localStorage.getItem('jwt_token')
        const response = await axios.post('/api/v1/admin/idcard/audit', {
          id: idcard.id,
          audit_status: 2,
          fail_reason: ''
        }, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })
        
        if (response.data.code === 200) {
          ElMessage.success('审核通过成功')
          fetchPendingIdcards()
        } else {
          ElMessage.error(response.data.message || '审核通过失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('Error approving idcard:', error)
          ElMessage.error('审核通过失败')
        }
      } finally {
        idcard.approving = false
      }
    }

    // 快速拒绝
    const quickDeny = (idcard) => {
      denyForm.value = {
        id: idcard.id,
        failReason: ''
      }
      denyDialogVisible.value = true
    }

    // 选择预定义拒绝原因
    const selectPredefinedReason = (reason) => {
      auditForm.value.failReason = reason
    }

    // 选择预定义拒绝原因（快速拒绝对话框）
    const selectQuickDenyReason = (reason) => {
      denyForm.value.failReason = reason
    }

    // 确认拒绝
    const confirmDeny = async () => {
      if (!denyForm.value.failReason.trim()) {
        ElMessage.error('请填写拒绝原因')
        return
      }

      try {
        await ElMessageBox.confirm(
          '确定要拒绝该身份证审核吗？', 
          '确认拒绝', 
          {
            type: 'warning'
          }
        )

        submitting.value = true
        const token = localStorage.getItem('jwt_token')
        const response = await axios.post('/api/v1/admin/idcard/audit', {
          id: denyForm.value.id,
          audit_status: 3,
          fail_reason: denyForm.value.failReason
        }, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })
        
        if (response.data.code === 200) {
          ElMessage.success('审核拒绝成功')
          denyDialogVisible.value = false
          denyForm.value = { id: null, failReason: '' }
          fetchPendingIdcards()
        } else {
          ElMessage.error(response.data.message || '审核拒绝失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('Error denying idcard:', error)
          ElMessage.error('审核拒绝失败')
        }
      } finally {
        submitting.value = false
      }
    }

    onMounted(() => {
      fetchPendingIdcards()
    })

    return {
      loading,
      submitting,
      pendingIdcards,
      currentPage,
      pageSize,
      total,
      auditDialogVisible,
      auditDetail,
      auditForm,
      denyDialogVisible,
      denyForm,
      predefinedReasons,
      hasDetailedInfo,
      comparisonData,
      formatDate,
      getStatusText,
      getStatusType,
      getGenderText,
      viewAuditDetail,
      submitAudit,
      quickApprove,
      quickDeny,
      selectPredefinedReason,
      selectQuickDenyReason,
      confirmDeny,
      refreshList,
      handleSizeChange,
      handlePageChange,
      photoPathToUrl
    }
  }
}
</script>

<style scoped>

.audit-detail {
  padding: 20px 0;
}

.basic-info,
.idcard-images,
.recognition-info,
.detailed-info {
  margin-bottom: 30px;
}

.basic-info h3,
.idcard-images h3,
.recognition-info h3,
.detailed-info h3 {
  margin: 0 0 15px 0;
  font-size: 18px;
  color: #303133;
}

.image-row {
  display: flex;
  gap: 30px;
  justify-content: center;
}

.image-item {
  text-align: center;
}

.image-item h4 {
  margin: 0 0 10px 0;
  font-size: 16px;
  color: #606266;
}

.no-image {
  width: 300px;
  height: 200px;
  border: 1px dashed #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  background-color: #f5f7fa;
}

.audit-actions {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.action-buttons {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}

.reject-reasons {
  margin-top: 10px;
}

.predefined-reasons {
  margin-bottom: 20px;
}

.predefined-reasons h5,
.custom-reason h5 {
  margin: 0 0 10px 0;
  font-size: 14px;
  color: #606266;
  font-weight: 600;
}

.reason-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 15px;
}

.reason-buttons .el-button {
  margin: 0;
  font-size: 12px;
  padding: 6px 12px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.reason-buttons .el-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.selected-reason {
  background-color: #409eff !important;
  color: white !important;
  border-color: #409eff !important;
}

.selected-reason:hover {
  background-color: #337ecc !important;
  border-color: #337ecc !important;
}

.custom-reason {
  border-top: 1px solid #ebeef5;
  padding-top: 15px;
}

.no-image-text {
  color: #909399;
  font-size: 12px;
}

@media (max-width: 768px) {
  .image-row {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
  
  .image-item .el-image,
  .no-image {
    width: 250px;
    height: 160px;
  }
}

</style>